import React from 'react'
import styled from '@emotion/styled'
import TwoFactorForm from './TwoFactorForm'
import { MobileFriendly } from 'stylist'

const TwoFACodeContainer = styled.div`
  width: 80% !important;
  margin: auto;
`
const TextContainer = styled.div`
  margin: 0 0 20px;
  display: flex;
  width: 100%;
`

const Text = styled.div`
  width: 90%;
`

const StyledIcon = styled(MobileFriendly)`
  width: 10%;
`

const InstructionsContainer = styled.div`
  font-size: 10px !important;
  line-height: initial;
`
const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
`

const Divider = styled.div`
  border-bottom: 1px solid #f0eceb;
  margin-bottom: 19px;
`

const TwoFactorCode = ({ notify, authenticate }) => {
  return (
    <TwoFACodeContainer>
      <TextContainer>
        <StyledIcon />
        <Text>
          Enter the 6-digit code generated by Google Authenticator App.
        </Text>
      </TextContainer>
      <TwoFactorForm notify={notify} authenticate={authenticate} />
      <Divider />
      <InstructionsContainer>
        <p>
          To change your authentication device and set up Google Authenticator
          on a new device, follow{' '}
          <Link
            href="https://support.google.com/accounts/answer/1066447?hl=EN"
            target="_blank"
          >
            Authenticator setup instructions
          </Link>
        </p>
        <p>
          If you've lost your device or can't use your app, please contact{' '}
          <Link>support@forsta.com</Link>.
        </p>
      </InstructionsContainer>
    </TwoFACodeContainer>
  )
}

export default TwoFactorCode



// WEBPACK FOOTER //
// ./src/routes/login/components/TwoFactorCode.js